export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";